import React from 'react';
import Seo from '../common/Seo';

import CallToAction from "../common/CallToAction";
import Drawer from "../common/Drawer";
import Projects from "../home/Projects";
import PageTitle from "./include/PageTitle";

import { ReactComponent as MobileAppsIcon } from "../assets/skills/mobile_apps.svg";
import OtherSkills from "./include/OtherSkills";
import SkillProjects from "./include/Projects";
import Process from "./include/Process";
import Stack from "./include/Stack";

import { routeIds } from "../i18n/routes";
import { useI18n } from "../i18n/I18nContext";
import ProjectQuery from "../model/Projects";

import iOS from "../assets/skills/iOS.png";
import Android from "../assets/skills/Android.png";
import Swift from "../assets/skills/Swift.png";
import Kotlin from "../assets/skills/Kotlin.png";
import ObjectiveC from "../assets/skills/ObjectiveC.png";
import Java from "../assets/skills/Java.png";
import Flutter from "../assets/skills/Flutter.png";
import XD from "../assets/skills/XD.png";
import Figma from "../assets/skills/Figma.png";

function MobileApps({route}) {
  const { pathFor, t } = useI18n();
  const steps = t("expertise.mobileApps.steps");
  const projects = ProjectQuery({filter: "mobile-apps"});
  const techs = [
    { name: "iOS", logo: iOS },
    { name: "Android", logo: Android },
    { name: "Flutter", logo: Flutter },
    { name: "Swift", logo: Swift },
    { name: "Kotlin", logo: Kotlin },
    { name: "Objective-C", logo: ObjectiveC },
    { name: "Java", logo: Java },
    { name: "XD", logo: XD },
    { name: "Figma", logo: Figma }
  ];

  const title = t("expertise.mobileApps.title");
  const description = t("expertise.mobileApps.description");

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="apps-mobiles" title={t("expertise.mobileApps.heading")} text={t("expertise.mobileApps.intro")} logo={<MobileAppsIcon />} />,
    <div className="hidden bg-pink"></div>,
    <Process steps={steps} color="pink" />,
    <SkillProjects items={projects} color="pink" />,
    <Stack techs={techs} />,
    <CallToAction id="contact" title={t("expertise.mobileApps.ctaTitle")} text={t("expertise.mobileApps.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <OtherSkills mainSkill="mobile-apps" />,
    <Projects />,
    <Drawer route={route} />
  ];
}

export default MobileApps;
